import React, { useCallback, useRef, useEffect, useState, useContext } from 'react';
import {Prompt} from 'react-router';
import { io } from 'socket.io-client';
/*import axios from 'axios';
import { API_ENDPOINT } from '../utils/Constants';*/

import useLocalStorage from '../hooks/useLocalstorage';
import { MenuContext, PathContext } from '../App';
import { SNAPSHOT_API_URL, WS_ENDPOINT } from '../utils/Constants';

import styled from 'styled-components';
import noImg from '../images/noimg.png';
import { Content } from '../components/Layout';
import { SpinnerDesign } from '../style';
import { FilterDropdown, Button/*, ButtonWithLoading*/, Spinner } from 'scorer-ui-kit';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';


const Container = styled(Content) <{ marginLeft?: string }>`
  display: flex;
  flex: 1;
  margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '295px'};
  
  //height: auto;  
  //width: 700px;
  height: 100%;
  width: 100%;
  //max-width: 1500px;
  flex-direction: column;
  padding: 60px 50px 25px 50px;
  transition: 0.2s;
  //overflow: initial;
  /*& > div {
    max-width: auto;
  }*/
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 720px;
  height: 480px;  
  margin-top: 12%;
`;

const socket = io(WS_ENDPOINT);
const StopWatch = () => {
  const { setSelectedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage } = useLocalStorage();
  const [tasksetList, setTaskSetList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [selectedTaskset, setSelectedTaskset] = useState({'text': floorPlanStorage.tasksets[0].name, 'value': floorPlanStorage.tasksets[0].id, });
  const [selectedOperator, setSelectedOperator] = useState({'text': floorPlanStorage.operators[0].name, 'value': floorPlanStorage.operators[0].id, });

  const [ttjState, setTtjState] = useState(JSON.parse(JSON.stringify(floorPlanStorage.tasksets[0]))); // ttj = taskset + task + job
  const [jobNameExecute, setJobNameExecute] = useState('waiting');
  const [jobMiliSeconds, setJobMiliSeconds] = useState(0);
  const [manualIMG, setManualIMG] = useState(noImg);
  const [mainIMG, setMainIMG] = useState(SNAPSHOT_API_URL + '?p=' + new Date().getTime());

  const [isStarting, setIsStarting] = useState(false);
  const [isStoping, setIsStoping] = useState(true);
  const [isLoading, setIsLoading] = useState(false);


  const jobInterval = useRef();
  const resetTimer = () => {
    clearInterval(jobInterval.current);
    setJobMiliSeconds(0);
  };

  // tasksetList、operatorList,manualIMG初期化
  useEffect(() => {
    const t = [];
    for(let i = 0; i < floorPlanStorage.tasksets.length; i++){
      t.push({'text': floorPlanStorage.tasksets[i].name, 'value': floorPlanStorage.tasksets[i].id,});
    }
    setTaskSetList(t);

    const o = [];
    for(let i = 0; i < floorPlanStorage.operators.length; i++){
      o.push({'text': floorPlanStorage.operators[i].name, 'value': floorPlanStorage.operators[i].id,});
    }
    setOperatorList(o);

    for(let k = 0; k < floorPlanStorage.jobs.length; k++){  // manual
      if (floorPlanStorage.jobs[k].id === floorPlanStorage.tasksets[0].taskList[0].jobList[0].id){
        setManualIMG(floorPlanStorage.jobs[k].manual);
      }
    }
  }, [floorPlanStorage]);

  /*---------websocket,処理済み情報取得---------*/
  //job変化したらtimer保存,manual変更
  const saveJobTimer = useCallback((jobName) => {  
    if (jobNameExecute !== jobName){
      // manual
      for(let n = 0; n < floorPlanStorage.jobs.length; n++){
        if (floorPlanStorage.jobs[n].name === jobName){
          setManualIMG(floorPlanStorage.jobs[n].manual);
        }
      }

      if (jobNameExecute === 'waiting'){
        setJobNameExecute(jobName);
        return;
      }
      // timer
      const newTTJ = JSON.parse(JSON.stringify(ttjState));
      for (let i = 0 ; i < ttjState.taskList.length; i++){
        for (let k = 0 ; k < ttjState.taskList[i].jobList.length; k++){
          if (jobNameExecute === ttjState.taskList[i].jobList[k].name){
            //各jobの計測時間加算
            newTTJ.taskList[i].jobList[k].timer ?
              newTTJ.taskList[i].jobList[k].timer = newTTJ.taskList[i].jobList[k].timer + jobMiliSeconds :
              newTTJ.taskList[i].jobList[k].timer = jobMiliSeconds;
            //各taskの計測時間加算
            newTTJ.taskList[i].timer ?
              newTTJ.taskList[i].timer = newTTJ.taskList[i].timer + jobMiliSeconds :
              newTTJ.taskList[i].timer = jobMiliSeconds;
            //tasksetの計測時間加算
            newTTJ.timer ?
              newTTJ.timer = newTTJ.timer + jobMiliSeconds :
              newTTJ.timer = jobMiliSeconds;

            setTtjState(newTTJ);
            setJobNameExecute(jobName);
            return;
          }
        }
      }
    }
  }, [jobNameExecute, ttjState, jobMiliSeconds, floorPlanStorage]);

  //websocket通信
  useEffect(() => {
    socket.on('react_Receiver_AnalyzedResults', (data) => {
      setMainIMG('data:image/jpg;base64,' + Buffer.from(data.mainIMG, 'binary').toString('base64'));
      if (data.ttj_state && !isStoping) {
        isLoading && setIsLoading(false);
        const jsonData = JSON.parse(data.ttj_state);
        jsonData.job_name_execute !== 'NoPeople' && saveJobTimer(jsonData.job_name_execute);
      }
    });
    return () => {
      socket.off('react_Receiver_AnalyzedResults');
    };
  }, [saveJobTimer, isLoading, isStoping]);
  /*---------websocket,処理済み情報取得---------*/


  /*---------job timer---------*/
  useEffect(() => {
    resetTimer();
    if (jobNameExecute === 'waiting'){
      return;
    }else{
      jobInterval.current = setInterval(() => {
        setJobMiliSeconds(prevCount => prevCount + 1);
      }, 100);
    }
  }, [jobNameExecute]);
  /*---------job timer---------*/
  
  /*---------計測タスクセット選択---------*/
  const handle_TaskSetSelecte = (ev) => {
    setSelectedTaskset(ev);
    if (ev.value === -1){
      setTtjState({});
      setManualIMG(noImg);
      return;
    }
    // get ttj and task[0]job[0].manual
    for(let i=0; i<floorPlanStorage.tasksets.length; i++){
      if (floorPlanStorage.tasksets[i].id === ev.value) {
        setTtjState(JSON.parse(JSON.stringify(floorPlanStorage.tasksets[i])));
        for(let k = 0; k < floorPlanStorage.jobs.length; k++){  // manual
          if (floorPlanStorage.jobs[k].id === floorPlanStorage.tasksets[i].taskList[0].jobList[0].id){
            setManualIMG(floorPlanStorage.jobs[k].manual);
          }
        }
      }
    }
  };
  /*---------計測タスクセット選択---------*/


  /*---------start stop button---------*/
  const handleStart = () => {
    socket.emit('server_StartStopButtonPress', {'state': 'start', 'taskset_ID': selectedTaskset.value, 'operator_ID': selectedOperator.value});
    setIsStarting(true);
    setIsStoping(false);
    setIsLoading(true);
    for (let i = 0; i < 20; i++){
      setTimeout(() => {
        setIsLoading(true);
      }, 50);
    }
  };
  const handleStop = () => {
    socket.emit('server_StartStopButtonPress', {'state': 'stop'});
    setJobNameExecute('waiting');
    resetTimer();
  
    setIsStoping(true);
    setIsLoading(true);
    setTimeout(() => {  
      socket.emit('server_StartStopButtonPress', {'state': 'stop'});
      setIsStarting(false);
      setIsLoading(false);
    }, 2000);
  };
  // Reset
  const handleReset = () => {
    handleStop();
    for(let i=0; i<floorPlanStorage.tasksets.length; i++){
      if (floorPlanStorage.tasksets[i].id === selectedTaskset.value) {
        setTtjState(JSON.parse(JSON.stringify(floorPlanStorage.tasksets[i])));
        for(let k = 0; k < floorPlanStorage.jobs.length; k++){  // manual
          if (floorPlanStorage.jobs[k].id === floorPlanStorage.tasksets[i].taskList[0].jobList[0].id){
            setManualIMG(floorPlanStorage.jobs[k].manual);
          }
        }
      }
    }
    setIsStarting(false);
    setIsStoping(true);
  };
  /*---------start stop button---------*/


  /*---------route---------*/
  useEffect(() => {
    if (pathUpdated) {
      setSelectedStep(0);
    }
  }, [pathUpdated, setSelectedStep]);
  /*---------route---------*/

  return (
    <Container>
      <Prompt
        message={() => {
          socket.emit('server_StartStopButtonPress', {'state': 'stop'});
          return true;
        }}
      />
      <h1>作業計測</h1>
      <Stack spacing={2}>
        <Stack direction='row' spacing={2}>
          {isStarting ? 
            <FilterDropdown
              disabled
              buttonIcon='MetaCategories'
              buttonText={selectedTaskset.text}
              loadingText='ローディング...'
              searchPlaceholder='タスクセット名'
              searchResultText='[VISIBLE]件'
              optionType='text'
              selected={[selectedTaskset]}
              list={tasksetList}
              maxDisplayedItems={10}
              onSelect={handle_TaskSetSelecte}
            />
            :
            <FilterDropdown
              buttonIcon='MetaCategories'
              buttonText={selectedTaskset.text}
              loadingText='ローディング...'
              searchPlaceholder='タスクセット名'
              searchResultText='[VISIBLE]件'
              optionType='text'
              selected={[selectedTaskset]}
              list={tasksetList}
              maxDisplayedItems={10}
              onSelect={handle_TaskSetSelecte}
            />}
          {isStarting ? 
            <FilterDropdown
              disabled
              buttonIcon='MetaCategories'
              buttonText={selectedOperator.text}
              loadingText='ローディング...'
              optionType='text'
              searchPlaceholder='オペレーター...'
              searchResultText='[VISIBLE]件'
              selected={[selectedOperator]}
              list={operatorList}
              maxDisplayedItems={10}
              onSelect={(newSelection: any) => { setSelectedOperator(newSelection); }}
            />
            :
            <FilterDropdown
              buttonIcon='MetaCategories'
              buttonText={selectedOperator.text}
              loadingText='ローディング...'
              optionType='text'
              searchPlaceholder='オペレーター...'
              searchResultText='[VISIBLE]件'
              selected={[selectedOperator]}
              list={operatorList}
              maxDisplayedItems={10}
              onSelect={(newSelection: any) => { setSelectedOperator(newSelection); }}
            />}
          <Button disabled={isStarting} design='primary' size='small' onClick={handleStart}>Start</Button>
          <Button disabled={isStoping} design='primary' size='small' onClick={handleStop}>Stop</Button>
          <Button disabled={isStarting} design='primary' size='small' onClick={handleReset}>Reset</Button>
        </Stack>

        <Stack direction='row' spacing={2}>

          {isLoading ?
            <SpinnerWrapper>
              <Spinner size='large' styling={SpinnerDesign} />
            </SpinnerWrapper>
            :
            <img width={720} height={480} alt='' src={mainIMG} />}

          <div style={{ width: '20%' }}>
            <Box
              component='span'
              sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#101010' : '#fff',
                color: (theme) =>
                  theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                  theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.9rem',
                fontWeight: '700'
              }}
            >
              <p>タスク詳細：</p>
              <p>{selectedTaskset.text}{ttjState.timer && '　('+ttjState.timer/10+'秒)'}</p>
              {ttjState.taskList && ttjState.taskList.map((task) => {
                return (
                  <>
                    <p key={task.id+'-'+task.name}>{'- '}{task.name}{task.timer && '　('+task.timer/10+'秒)'}</p>
                    {task.jobList.map((job) => {
                      return <p key={job.id+'-'+job.name}>{'--- '}{job.name}{job.timer && '　('+job.timer/10+'秒)'}</p>;
                    })}
                  </>
                );
              })}
            </Box>
          </div>
          <Stack spacing={2}>
            <Box
              component='span'
              sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#101010' : '#fff',
                color: (theme) =>
                  theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                  theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.9rem',
                fontWeight: '700',
                padding: '20px'
              }}
            >
              <p>現在実行中のジョブ：{jobNameExecute}
              </p>
              <p>経過時間：{jobMiliSeconds/10} 秒</p>
            </Box>
            <img width={400} height={400} alt='' src={manualIMG} />
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default StopWatch;


